import getAllTasks from './adapter';
import task_0 from './minigames/initTasks/task_0';
import task_0_1 from './minigames/initTasks/task_0_1';
import task_0_2 from './minigames/initTasks/task_0_2';
import task_0_3 from './minigames/initTasks/task_0_3';
import task_0_4 from './minigames/initTasks/task_0_4';

export let alltasks = getAllTasks;

export let tasks = [
    task_0,
    task_0_4,
    task_0_1,
    task_0_2,
    task_0_3
];

